var $ = require('jquery');

$(function () {
    var isPageEditor = window.SitecoreUtilities.isPageEditor;

    if (isPageEditor()) {
        $(".people-results").show();
        $(".people-search-query__container").html("People Search Results Module");
        return false;
    } else {
        var page = 1;
        var contentPaginated = false;

        //enter press for header search
        $(".search__textbox").on("keypress",
            function (e) {
                if (e.keyCode === 13) {
                    $(".search__button").click();
                }
            }
        );

        //enter press for search page
        $(".people-search-page__textbox").on("keypress",
            function (e) {
                if (e.keyCode === 13) {
                    $(".people-search-page__submit").click();
                }
            }
        );

        //search page search function
        $(".people-search-page__submit").on("click",
            function (e) {
                showLoadingImg(true);
                submitSearch(e, true);
            });

        function submitSearch(e, resetPageNumber) {
            if (!!resetPageNumber) {
                page = 1;
            }
            var buttonHandle = this || $(".people-search-page__submit")[0];
            if (!!e) {
                e.preventDefault();
            }
            var payload = $($(".people-search-page__textbox"))[0].value;

            if (payload === "*") {
                $($(".people-search-page__textbox"))[0].value = "";
                payload = "";
            }

            //update the url so backbutton works
            if (contentPaginated) {
                window.history.pushState(payload,
                    payload,
                    window.location.pathname + "?q=" + payload + "&page" + page);
            } else {
                window.history.pushState(payload,
                    payload,
                    window.location.pathname + "?q=" + payload);
            }
            $.ajax({
                url: "/api/Sitecore/PeopleSearchResults/HandleFilterSubmit",
                type: "POST",
                context: this,
                data: {
                    payload: payload,
                    page: page,
                    pageSize: $(".people-results").data("page-size"),
                    contextId: $(".people-search-page").data("page-id"),
                    contextLang: $(".people-search-page").data("page-language") || $('html').attr('lang'),
                    checkedServices: $("#ServicesDropDown").val(),
                    checkedIndustries: $("#IndustriesDropDown").val(),
                    checkedRoles: $("#RolesDropDown").val()
                },
                success: function (data) {
                    if (data.error) {
                        console.error("an error occured " + data.errorMessage);
                        return;
                    }

                    if (data.redirect) {
                        window.location.href = data.redirect;
                    }

                    if (!!data.suggestion) {
                        var search = window.location.href;
                        var replace = search.replace("q=" + encodeURIComponent(payload),
                            "q=" + encodeURIComponent(data.suggestion));

                        $(".people-search-criteria__suggestion").show();
                        $(".people-search-criteria__suggestion-link").attr("href", replace);
                        $(".people-search-criteria__suggestion-link").text(data.suggestion);
                    } else {
                        $(".people-search-criteria__suggestion").hide();
                    }

                    $(".people-results").replaceWith(data.contentResults);
                    $(".people-results").show();
                },
                error: function (data) {
                    console.error(data);
                }
            });
        }

        //enter press for search page
        $(".people-search-page__textbox").on("keypress",
            function (e) {
                if (e.keyCode === 13) {
                    submitSearch(null, true);
                    $(".people-search-page__textbox").blur();
                }
            }
        );

        //search if on search page and querystring is filled in 
        if ($(".people-search-page__textbox").length > 0 && GenericUtilities.getQueryString("q")) {
            if (GenericUtilities.getQueryString("page") && $.isNumeric(GenericUtilities.getQueryString("page"))) {
                page = parseInt(GenericUtilities.getQueryString("page"));
            }
            $(".people-search-page__textbox").val(GenericUtilities.getQueryString("q"));

            if (GenericUtilities.getQueryString("redirect")) {
                if (GenericUtilities.getQueryString("s")) {
                    var service = GenericUtilities.getQueryString("s");
                    if ($("#ServicesDropDown option[value='" + service + "']").length != 0) {
                        $("#ServicesDropDown").val(service);
                    }
                }
                if (GenericUtilities.getQueryString("i")) {
                    var industry = GenericUtilities.getQueryString("i");
                    if ($("#IndustriesDropDown option[value='" + industry + "']").length != 0) {
                        $("#IndustriesDropDown").val(industry);
                    }
                }
                if (GenericUtilities.getQueryString("r")) {
                    var role = GenericUtilities.getQueryString("r");
                    if ($("#RolesDropDown option[value='" + role + "']").length != 0) {
                        $("#RolesDropDown").val(role);
                    }
                }
            }

            submitSearch(null, false);
        } else {
            $(".people-results").hide();
            $(".people-search-query__container").html("");
        }

        var scrollSpeed = 500;
        var scrollToTopOfResults = function () {
            $('html, body').animate({
                scrollTop: $(".people-results").offset().top
            },
                scrollSpeed);
        };

        //Content pagination code
        $("body").on("click",
            ".people-results__pagination__page",
            function (e) {
                e.preventDefault();
                contentPaginated = true;
                $(".people-results__results .loading").addClass("show");
                page = $(this).data("page");
                submitSearch(null, false);
                scrollToTopOfResults();
            }
        );
        $("body").on("click",
            ".people-results__pagination .left",
            function (e) {
                e.preventDefault();
                contentPaginated = true;
                $(".people-results__results .loading").addClass("show");
                page = page - 1;
                submitSearch(null, false);
                scrollToTopOfResults();
            }
        );
        $("body").on("click",
            ".people-results__pagination .right",
            function (e) {
                e.preventDefault();
                contentPaginated = true;
                $(".people-results__results .loading").addClass("show");
                page = page + 1;
                submitSearch(null, false);
                scrollToTopOfResults();
            }
        );

        function stripHTML(oldString) {
            return oldString.replace(/<(?:.|\n)*?>/gm, '');
        }

        // based on true / false either show the loading at the top or hide it and remove top class
        function showLoadingImg(showLoading) {
            if (showLoading) {
                $(".people-results__results .loading").addClass("show");
                $(".people-results__results .loading img").addClass("top");
            } else {
                $(".people-results__results .loading").removeClass("show");
                $(".people-results__results .loading img").removeClass("top");
            }
        }
    }
});
